import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BizRow.css";
import moment from "moment";
import axios from "axios";

const BizRow = ({
  title,
  description,
  img,
  rating,
  _id,
  username,
  userName,
  userPhone,
  setChild,
  category
}) => {
  let [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const onClickService = (e) => {
    setChild(true)
    setLoading(true)
    const now = moment().format();
    const displayNow = moment().format("LT");
    const ticketData = {
      title: title,
      rating: rating,
      serviceName: username,
      userName: userName,
      userPhone: userPhone,
      now: now,
      displayNow: displayNow,
      category: category
    };
    axios.post('/ticket', ticketData)
    .then((res)=>{
      console.log(res)
      navigate(`/${username}`, {
        state: {
          title: title,
          rating: rating,
          _id: _id,
          username: username,
          userName: userName,
          userPhone: userPhone,
          now: now,
          displayNow: displayNow,
          category:  category
        },
      });
      setChild(false)
      setLoading(false)
    })
    .catch((err)=>{
      console.log(err)
      navigate(`/${username}`, {
        state: {
          title: title,
          rating: rating,
          _id: _id,
          username: username,
          userName: userName,
          userPhone: userPhone,
          now: now,
          displayNow: displayNow,
          category:  category
        },
      });
      setChild(false)
      setLoading(false)
    })
  };

  if(loading) return null;
  return (
    <div
      onClick={(e) => onClickService(e)}
      className="card horizontal menu-item-card"
    >
      <img className="menu-item-image" src={img} alt={title} />
      <div className="menu-item-content">
        <article className="line-clamp-4">
          <h1 className="menu-item-title">{title}</h1>
          <br className="inline-spacer" />
          <p className="menu-item-description">{description}</p>
        </article>
        <div className="menu-item-price-row">
          <strong className="menu-item-price">{`$${rating}`}</strong>
          <strong className="menu-item-price">
            Select
          </strong>
        </div>
      </div>
    </div>
  );
};

export default BizRow;
